class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    const promoSection = document.querySelector('[data-section-type="scrolling-promotion"]');
    const promoWrapper = promoSection ? promoSection.closest('[id^="shopify-section"]') : null;

    if (promoWrapper) {
      // Fix promo bar at top
      promoWrapper.style.cssText += 'position:fixed!important;top:0!important;left:0!important;right:0!important;z-index:51!important;width:100%!important;';

      // Collapse m-header in-flow height (wrapper is fixed)
      this.style.minHeight = '0';
      this.style.height = '0';
      this.style.overflow = 'visible';

      // Spacer goes after the header section to push page content down
      // It needs to be promoH + headerH since both are fixed/out of flow
      var spacer = document.getElementById('promo-header-spacer');
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.id = 'promo-header-spacer';
        var mainContent = document.getElementById('MainContent');
        if (mainContent) {
          mainContent.parentNode.insertBefore(spacer, mainContent);
        }
      }

      const updateSpacer = () => {
        const promoH = promoWrapper.offsetHeight;
        const headerH = this.domNodes.headerWrapper.offsetHeight;
        spacer.style.height = (promoH + headerH) + 'px';
        this.domNodes.headerWrapper.style.setProperty('top', promoH + 'px', 'important');
      };

      updateSpacer();
      window.addEventListener('load', updateSpacer);
      window.addEventListener('resize', updateSpacer);
    }

    const promoH = promoWrapper ? promoWrapper.offsetHeight : 0;
    this.domNodes.headerWrapper.style.setProperty('top', promoH + 'px', 'important');

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      const ph = promoWrapper ? promoWrapper.offsetHeight : 0;
      this.domNodes.headerWrapper.style.setProperty('top', ph + 'px', 'important');

      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define("m-header", MHeader);
